module.exports = __webpack_public_path__ + "static/media/user.login.payment.461bdb77.svg";